var icon = require('vue-svgicon')
icon.register({
  'ks-icon-sort': {
    width: 128,
    height: 128,
    viewBox: '0 0 128 128',
    data: '<path pid="0" d="M39.52 72.21L64 96.69l24.48-24.48L96 79.79l-32 32-32-32zM88.48 51.79L64 27.31 39.52 51.79 32 44.21l32-32 32 32z"/>'
  }
})
